import { useI18n } from 'vue-i18n';
import locales from './locales.json';

const baseKey = 'passenger.documentType';

const getDocTypeText = (docType: string) => {
  const { t } = useI18n({
    messages: locales,
  });

  switch (docType) {
    case 'УЛ':
      return t(`${baseKey}.id`);
    case 'ПК':
      return t(`${baseKey}.passport`);
    default:
      return t(`${baseKey}.default`);
  }
};

const getPaxDocText = (docType: string, docNumber: string) => {
  const docTypeText = getDocTypeText(docType);
  return `${docTypeText} ${docNumber}`;
};

export const bookingPassengerLib = {
  getPaxDocText,
};
